<template>
	<div class="create-task-container" @click="close_selection += 1">
		<div v-if="item" class="top-line"></div>
		<div v-if="item" class="pt-3 px-6 task-title">
			<div class="title-text">
				<span v-if="isDuplication_local">Add Item</span>
				<span v-if="!isDuplication_local">Item</span>
			</div>
			<div class="task-title">
				<Copy v-if="!isDuplication_local" class="link-icon" style="height: 16px; width: 16px" :color="`rgba(25, 42, 62, 0.7)`" @click="onCopyItem()"/>
				<Delete v-if="!isDuplication_local" class="mt-1 ml-3 link-icon" style="height: 20px; width: 20px" :color="`rgba(25, 42, 62, 0.7)`" @click="onDeleteItem()"/>
				<v-icon @click.stop="onEditItemClose()">mdi-close</v-icon>
			</div>
		</div>
		<v-alert class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<ProgressLinear v-if="loading"/>
		<v-row class="px-3 ma-0">
			<v-col :cols="12">
				<div class="item-title-text mt-1">Job</div>
				<v-autocomplete
					v-model="job"
					:items="job_items"
					:loading="job_loading"
					:search-input.sync="job_search"
					:color="color"
					:background-color="'#FAFAFA'"
					:error="job ? !job.valid : false"
					item-text="display_name"
					item-value="id"
					item-color="success"
					item-disabled="disabled"
					autofocus
					auto-select-first
					outlined
					dense
					hide-details
					hide-no-data
					return-object
					clearable
					@change="onJobSelected($event)"
				>
					<template v-slot:prepend-inner>   
						<SuitCase color="rgba(25, 42, 62, 0.5)" width="24" height="24"/>
					</template>
				</v-autocomplete>
				<div v-if="job && !job.valid" class="optional-text-red">Item cannot be added to a Complete/Cancelled Job</div>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
				<div class="item-title-text">Phase</div>
				<v-select
					style="width: 100%"
					v-model="phase"
					:items="phase_items"
					:color="color"
					background-color="#FAFAFA"
					item-text="display_name"
					item-value="id"
					item-color="success"
					item-disabled="disabled"
					outlined
					dense
					hide-details
					return-object
					@change="onButtonActive()"
				>
					<template v-slot:prepend-inner>   
						<Phase color="rgba(25, 42, 62, 0.5)"/>     
					</template>
				</v-select>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
				<div class="item-title-text">Date</div>
				<DatePicker
					:style="$vuetify.breakpoint.mdAndDown ? 'width: 100%': ''"
					:isOutlined="true"
					:isIcon="true"
					:background="'#FAFAFA'"
					:color="color"
					:dateInit="init_date"
					@date="onDateChange($event)"
				/>
			</v-col>
			<v-col :cols="12">
				<LogItem
					:color="color"
					:bgColor="'#FAFAFA'"
					:open="true"
					:showRates="ratesPrivilege"
					:currencies="currencies" 
					:job="job"
					:phase="phase"
					:date="item_date"
					:itemParams="item_params"
					:editItem="edit_item"
					:isDuplication="isDuplication_local"
					:items="[init_item]"
					:closeSelection="close_selection"
					@items-change="onItemsChange($event)"
					@error-msg="error_msg = $event"
				/>
			</v-col>
			<v-col :cols="12">
				<v-btn v-if="item && !isDuplication_local" class="text-capitalize white--text" depressed block :color="color" :disabled="!isActive" @click="onUpdateItem()">Save Changes</v-btn>
				<v-btn v-if="item && isDuplication_local" class="text-capitalize white--text" depressed block :color="color" :disabled="!isActive" @click="onCreateItem()">Add Item</v-btn>
				<v-btn v-if="!item && !isDuplication_local" class="text-capitalize white--text" depressed block :color="color" :disabled="!isActive" @click="onCreateItem()">Create Item</v-btn>
			</v-col>
		</v-row>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
		/>
		<DeleteConfirmDialog 
			v-if="unsaved_visible"
			:visible="unsaved_visible" 
			:color="'error'"
			:title="`Unsaved changes`" 
			:content="'Are you sure you want to leave this window without saving changes?'"
			:ok="'Yes, exit'"
			:icon_name_title="'mdi-alert-circle'"
			:icon_name_front="'mdi-delete-outline'"
			:maxWidth="500"
			@cancel="unsaved_visible = false"
			@ok="$emit('close')"
		/>
		<DeleteConfirmDialog 
			v-if="delete_visible"
			:visible="delete_visible" 
			:color="'error'"
			:title="`You are about to delete this Item.`" 
			:content="`This action cannot be undone. Are you sure?`"
			:ok="'Yes, delete'"
			:icon_name_title="'mdi-alert-circle'"
			:icon_name_front="'mdi-delete-outline'"
			:maxWidth="500"
			@cancel="delete_visible = false"
			@ok="onDelete($event)"
		/>
	</div>
</template>
<script>
import SuitCase from "@/components/icons/suitcase.vue";
import Phase from "@/components/icons/phase.vue";
import Copy from '@/components/icons/copy';
import Delete from '@/components/icons/delete_outline';
import DatePicker from "@/components/date/date_picker.vue";
import LogItem from "@/views/items/log_item.vue";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";
import config from "@/config.js";
import moment from 'moment';

const DescriptionLimit = 60;
const Completed_Phase = 1;
const TPc = 'TPc';
const JOr = 'JOr';
const TSr = 'TSr';

const Any_Mode = 1;
const Overhead_Mode = 2;

const Event_Task = 'task';
const Event_Timesheet = 'timesheet';
const Event_Item = 'item';

export default {
	name: 'NewItem',
	props: {
		color: {
			type: String,
			default: ''
		},
		item: {
			type: Object,
			default: null
		},
		isDuplication: {
			type: Boolean,
			default: false
		},
		joid: {
			type: Number,
			default: 0
		},
		startTime: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			loading: false,
			error_msg: '',
			job_invalid_status_ids: [],
			isActive: false,
			isDuplication_local: this.isDuplication,

			job: { id: 0, display_name: '', valid: true },
			job_items: [],
			job_loading: false,
			job_search: null,

			phase: null,
			phase_items: [],

			init_date: moment().format('YYYY-MM-DD'),
			item_date: moment().format('YYYY-MM-DD'),

			init_item: {
				id: 0,
				item_id: 0,
				units: 0,
				currency: null,
				charge_rate: 0,
				kind: null,
				notes: ''
			},
			edit_item: null,
			item_params: {
				select_kinds: false,
				select_items: true,
				overhead_mode: 0,
				include_system_kinds: 'ACREV'
			},
			items: [],

			currencies: [],

			unsaved_visible: false,
			delete_visible: false,

			visible_notice: false,
			notice_text: [],
			tid: null,

			button_click_flag: false,
			close_selection: 0,
		}
	},
	components: {
		DialogNotice,
		SuitCase,
		Phase,
		Copy,
		Delete,
		DatePicker,
		LogItem,
		ProgressLinear,
		DeleteConfirmDialog
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	watch: {
		job_search(val) {
			if (this.job) {
				val && val !== this.job.display_name && this.jobQuery(val);
			} else {
				val && this.jobQuery(val);
			}
		},
	},
	computed: {
		completedPhasePrivilege() {
			let isCompletedPhasesTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TPc)) {
				isCompletedPhasesTmp = true;
			}
			return isCompletedPhasesTmp;
		},
		completedJobPrivilege() {
			let isCompletedJobTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(JOr)) {
				isCompletedJobTmp = true;
			}
			return isCompletedJobTmp;
		},
		ratesPrivilege() {
			let isRatesTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TSr)) {
				isRatesTmp = true;
			}
			return isRatesTmp;
		}
	},
	async created() {
		await this.getJobStatusIds();
		await this.getCurrencies();

		if (this.item) {
			if (this.item.type === Event_Item || this.item.type === Event_Timesheet) {
				this.init_date = this.item.date;
				this.item_date = this.item.date;
			}

			if (this.item.type === Event_Task) {
				this.init_date = this.item.task_days > 1 ? moment().format('YYYY-MM-DD') : moment(this.item.date, ['YYYYMMDD', 'YYYY-MM-DD']).format('YYYY-MM-DD');
				this.item_date = this.item.task_days > 1 ? moment().format('YYYY-MM-DD') : moment(this.item.date, ['YYYYMMDD', 'YYYY-MM-DD']).format('YYYY-MM-DD');
			}

			const item_obj = JSON.parse(JSON.stringify(this.item));

			if (this.item.type === Event_Item) {
				const init_item_obj = {
					id: 0,
					item_id: item_obj.id,
					units: item_obj.units,
					currency: item_obj.value_currency,
					charge_rate: item_obj.item_charge_rate_FC,
					kind: item_obj.kind,
					date: item_obj.date,
					job_id: item_obj.job.id,
					notes: item_obj.notes
				};
				this.edit_item = init_item_obj;
			}
			if (this.item.type === Event_Task || this.item.type === Event_Timesheet) {
				const init_item_obj = {
					id: 0,
					item_id: 0,
					units: 0,
					currency: null,
					charge_rate: 0,
					kind: null,
					date: '',
					job_id: item_obj.job.id
				};
				this.edit_item = init_item_obj;
			}

			await this.getJob(this.item.job.id, true);
		}

		if (this.joid !== 0) {
			this.getJob(this.joid);
		}

		if (this.startTime) {
			this.init_date = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD');
			this.item_date = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD');
		}
	},
	methods: {
		async getJobStatusIds() {
			const url = '/api/jobs/meta';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const statuses_arr = data.substatusses;
						const job_invalid_statusses = statuses_arr.filter(s => { return !config.job_status_group_nomal.includes(s.group) });
						this.job_invalid_status_ids = job_invalid_statusses.map(s => { return s.id });
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getCurrencies() {
			const url = '/api/expenses/receipts/meta';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.currencies = data.currencies;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getJob(id, is_init=false) {
			this.loading = true;

			const url = `/api/jobs/${id}`;
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const description = data.description.length > DescriptionLimit
							? data.description.slice(0, DescriptionLimit) + '...'
							: data.description;

						let is_valid = true;
						if (this.completedJobPrivilege) {
							is_valid = this.job_invalid_status_ids.includes(data.status.id) ? false : true;
						}

						const obj = {
							id: data.id,
							display_name: `${data.code} - ${description}`,
							overhead: data.is_overhead || data.job_type.overhead_mode === 1 || data.job_type.code === 'OVER',
							currency: data.currency,
							disabled: false,
							valid: is_valid
						};

						this.job = obj;
						this.job_items.push(obj);

						if (this.item && this.item.type !== Event_Item) {
							this.edit_item.currency = data.currency;
						}

						this.getPhase(obj.id, is_init);
						this.item_params.overhead_mode = obj.overhead ? Overhead_Mode : Any_Mode;

						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		jobQuery(key) {
			this.job_loading = true;
			const params = [];
			params.push("code_and_name=" + encodeURIComponent(key));

			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						const code_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return code_lowercase.includes(key_lowercase);
						});
						
						const desc_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return !code_lowercase.includes(key_lowercase);
						});

						const data_filter = [...code_data, ...desc_data];
						
						this.job_items = data_filter.map(d => {
							const description = d.display_name.length > DescriptionLimit
								? d.display_name.slice(0, DescriptionLimit) + '...'
								: d.display_name;
							
							let is_disabled = false;
							if (this.completedJobPrivilege) {
								is_disabled = this.job_invalid_status_ids.includes(d.status.id) ? true : false;
							}

							const obj = {
								id: d.id,
								display_name: description,
								overhead: d.is_overhead,
								currency: d.currency,
								disabled: is_disabled,
								valid: true
							};

							return obj;
						});

					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.job_loading = false
				});
		},
		onJobSelected(job_selected) {
			if (job_selected) {
				this.getPhase(job_selected.id);				
				this.init_item.currency = job_selected.currency;
				this.item_params.overhead_mode = job_selected.overhead ? Overhead_Mode : Any_Mode;
			} else {
				this.phase = null;
				this.phase_items = [];
				this.init_item.currency = null;
				this.item_params.overhead_mode = 0;
			}

			this.onButtonActive();
		},
		getPhase(job_id, is_init=false) {
			axios.get('/api/jobs/' + job_id + '/phases', {
				headers: {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"
				}
			})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						data.forEach(d => {
							if (this.completedPhasePrivilege) {
								d['disabled'] = false;
							} else {
								d['disabled'] = d.status === Completed_Phase ? true : false;
							}
						});
						this.phase_items = data;

						// auto assign our phase if there is only one..
						const phases_arr = data;
						
						if (is_init) {
							this.phase = this.item.phase;
						} else {
							this.phase = phases_arr[0];
						}
						
						this.onButtonActive();
					} else {
						this.error_msg = reason;
					}

				})
				.catch(msg => {
					this.error_msg = msg;
				})
		},
		onDateChange(date) {
			this.item_date = date === null ? '' : date;
			this.onButtonActive();
		},
		onItemsChange(items) {
			this.items = items;
			this.onButtonActive();
		},
		async onCreateItem() {
			if (this.button_click_flag) return;

			this.button_click_flag = true;

			const params_arr = [];
			for (let index = 0; index < this.items.length; index++) {
				const element = this.items[index];

				const params = {};
				params['date'] = moment(this.item_date).format('YYYYMMDD');
				params['units'] = typeof(element.units) === 'string' ? Number(element.units) : element.units;
				params['phase_id'] = this.phase.id;
				params['kind_id'] = element.kind.id;
				params['currency_id'] = element.currency.id;
				params['item_value'] = element.charge_rate * element.units;

				if (element.notes && element.notes.length !== 0) {
					params['notes'] = element.notes;
				}

				params_arr.push(params);
			}

			const url = params_arr.length === 1 ? '/api/items' : '/api/items/multipleitems';
			const params_req = params_arr.length === 1 ? params_arr[0] : { items : params_arr };

			axios
				.post(url, params_req, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, reason } = json;

					if (status == "OK") {
						this.notice_text.push('Item has been created successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.button_click_flag = false;
				});
		},
		onUpdateItem() {
			if (this.button_click_flag) return;

			const url = `/api/items/${this.item.id}`;
			const params = {};
			params['date'] = moment(this.item_date).format('YYYYMMDD');

			const units = typeof(this.items[0].units) === 'string' ? Number(this.items[0].units) : this.items[0].units;
			params['units'] = units;

			params['phase_id'] = this.phase.id;
			params['kind_id'] = this.items[0].kind.id;
			params['currency_id'] = this.items[0].currency.id;
			params['item_value'] = this.items[0].charge_rate * units;

			if (this.items[0].notes && this.items[0].notes.length !== 0) {
				params['notes'] = this.items[0].notes;
			}

			this.button_click_flag = true;

			axios
				.put(url, params, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const {status, reason} = val.data;

					if (status == "OK") {
						this.notice_text.push('Item has been updated successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.button_click_flag = false;
				});
		},
		onEditItemClose() {
			if (this.isActive) {
				this.unsaved_visible = true;
			} else {
				this.$emit('close');
			}
		},
		onDeleteItem() {
			if (this.isDuplication_local) return;

			this.delete_visible = true;
		},
		onDelete() {
			const url = `/api/items/${this.item.id}`;

			axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, reason} = val.data;

					if (status == "OK") {
						this.delete_visible = false;

						this.notice_text.push(`Item has been deleted successfully.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		onCopyItem() {
			if (this.isDuplication_local) return;

			this.isDuplication_local = true;
			this.isActive = this._isActive();
		},
		onButtonActive() {
			this.isActive = this._isActive();
		},
		_isActive() {
			let active_tmp = false;
			
			if (this.item && !this.isDuplication_local) {
				if (this.job && this.job.id !== 0 && this.job.valid && this.phase && this.item_date.length !== 0) {
					const item_selected = this.items.every(i => { return i.item_id !== 0 && i.kind !== null });
					const item_units = this.items.every(i => { return i.units !== 0 && i.units !== '0' });
					if (item_selected && item_units && this.items.length !== 0) {
						if (this.job.id !== this.item.job.id || this.phase.id !== this.item.phase.id || this.item_date !== this.item.date) {
							active_tmp = true;
						}
						if (this.items.length > 1) {
							active_tmp = true;
						}
						if (this.items.length === 1) {
							const new_units =  typeof(this.items[0].units) === 'string' ? Number(this.items[0].units) : this.items[0].units;
							const old_units = typeof(this.item.units) === 'string' ? Number(this.item.units) : this.item.units;
							if (new_units !== old_units || (this.items[0].kind && this.items[0].kind.id !== this.item.kind.id) || this.items[0].currency.id !== this.item.value_currency.id || this.items[0].charge_rate !== this.item.item_charge_rate_FC || this.items[0].notes !== this.item.notes) {
								active_tmp = true;
							}
						}
					}
				}
				
			} else {
				if (this.job && this.job.id !== 0 && this.job.valid && this.phase && this.item_date.length !== 0) {
					const item_selected = this.items.every(i => { return i.kind !== null });
					const item_units = this.items.every(i => { return i.units !== 0 && i.units !== '0' });
					
					if (item_selected && item_units && this.items.length !== 0) {
						active_tmp = true;
					}
				}
			}

			return active_tmp
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
			this.$emit('close');
		}
	}
}
</script>
<style lang="scss" scoped>
.create-task-container {
  background: #FFFFFF;
  border-radius: 4px;
  max-width: 100%;
}
.top-line {
  width: 100%;
  height: 4px;
  background: #81CC00;
  border-radius: 4px 4px 0px 0px;
}
.task-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #81CC00;
}
.item-title-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #37495F;
}
.optional-text-red {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;

	color: #F45252;
}

.link-icon {
	&:hover {
		cursor: pointer;
	}
}
</style>